import React from 'react';
import { ProgressStateModel } from 'eTip--common';
import { ProgressContent } from "common--design-library";

export interface IAppLoaderMtsProps {
    loadingText: string;
    minHeight: string; // with value for css (with units)
}

export const AppLoaderMts: React.FC<IAppLoaderMtsProps> = (props: IAppLoaderMtsProps) => {
    // same in web, containing page, initial content of reactAppRoot element
    return <div className="d-flex justify-content-center flex-column align-items-center app-loader" style={{ minHeight: props.minHeight }}>
        <div className="app-loader__info"><span className="fas fa-spinner fa-spin"></span> {props.loadingText} </div>
    </div>
}

export interface IAppLoaderProps {
}
export const AppLoader: React.FC<IAppLoaderProps> = (_props: IAppLoaderProps) => {
    return <ProgressContent state={ProgressStateModel.Loading} />

}
